module.exports = __webpack_public_path__ + "static/media/crack.cc6fc737.jpeg";